import { render, staticRenderFns } from "./meuMenu.vue?vue&type=template&id=1ebd10fb&"
import script from "./meuMenu.vue?vue&type=script&lang=js&"
export * from "./meuMenu.vue?vue&type=script&lang=js&"
import style0 from "./meuMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports